import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'

import "bootstrap/dist/css/bootstrap.css";

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import StandingsRank from './StandingsRank'
import StandingsAngler from './StandingsAngler'
import StandingsTotal from './StandingsTotal'
import StandingsHeader from './StandingsHeader'
import StandingsFishScores from './StandingsFishScores'
import StandingsKey from './StandingsKey'
import StandingsDayTotals from './StandingsDayTotals'

import {config} from '../config'

const txdomain = config()['tourneyx-url']


//Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day. Added fish_caught_day var 
const StandingsFish = ({score, tournament_event_type, fish_caught_day, type, photo, status,measurement_type,user_information,formatted_date_taken,formatted_date_submitted,length_measurement_symbol,weight_measurement_symbol,hide_fish_records}) => {
  const [show, setShow] = useState(false);
  

  //console.log('user_information value in StandingsFish:::',user_information);

  //console.log('hide_fish_records value passed in StandingsFish:::',hide_fish_records);

  const handleClose = (event) => {
    setShow(false)
  }
  const handleShow = () => {
    setShow(true);
  }

  function RenderTooltip(props){
    return <Tooltip {...props}>
      Click the X to view fish image. Picture Taken: {formatted_date_taken} Fish submitted: {formatted_date_submitted}
    </Tooltip>
  }
  //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day create new function display fish caught day with fish length.
  function getSubmissionFishCaught(){
    // To fix blank day issue for other tournament
     //Naveen 30/Jan/2024::TP-349 added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' 
    if (fish_caught_day == null || fish_caught_day == 0 || fish_caught_day == false ||tournament_event_type == 'per_event') {
      return;
    }else{
      return  <OverlayTrigger placement="bottom" overlay={RenderTooltip} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} >
        <div className="standings-fish-score">{`Day `} {fish_caught_day}</div>
      </OverlayTrigger>
    }
  }

  function getSubmissionScores(){
    return  <OverlayTrigger placement="bottom" overlay={RenderTooltip} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} >
      <div className="standings-fish-score">{score}{length_measurement_symbol}</div>
    </OverlayTrigger>
  }

  function getSubmissionWeightScores(){
    return  <OverlayTrigger placement="bottom" overlay={RenderTooltip} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} >
        <div className="standings-fish-score">{score}{weight_measurement_symbol}</div>
    </OverlayTrigger>
 
  }



  if(measurement_type == 'length'){
   
    return (

      // Below condition is for super-admin role
      (user_information && user_information.role === '1') ?
        <td className="center">
          <small className="submission-fish-id">ID:{photo}</small>
          <br></br>
           {
            //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day display fish caught day with fish length. 
           (fish_caught_day && fish_caught_day >= '1') 
            ? getSubmissionFishCaught() 
            :
            ''
            }
            {getSubmissionScores()}

          { (status === "1" || status === 1)
            ?
            <div className="standings-fish-accepted"><small>{type}</small></div>
            :
            <div className="standings-fish-new"><small>{type}</small></div>
          }
          <div className="icon-row">
          <a target="#" onClick={handleShow}>
            {(status === "1" || status === 1)
              ? <img src="/leaderboard/green28x.png" alt="Click to view" title="Click to view"/>
              : <img  src="/leaderboard/red28x.png" alt="Click to view" title="Click to view"/>}
          </a>
          </div>

          <Modal dialogClassName="pic-modal" show={show} onHide={handleClose} animation={false} centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body style={{'height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} >
              <div className='fish-img'>
                <img src={`${txdomain}/app/lib/php/show_image.php?s=${photo}`} onClick={handleClose}
                  onError={(e) => e.target.src = '/no_submit_photo2.jpg'} />
              </div>          
            </Modal.Body>
        
          </Modal>

        </td>

        :

        // Below condition is for other users 
        <td className={` center ${hide_fish_records && hide_fish_records == '1' ? 'opacity-class' :''}`}>
           { 
           //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day display fish caught day with fish length. function call.
             getSubmissionFishCaught() 
           
            
          }
      
          { (hide_fish_records && hide_fish_records == '1')
            ?
            <></>
            :
          
            getSubmissionScores()
          }
        

          { (status === "1" || status === 1)
            ?
            <div className="standings-fish-accepted"><small>{type}</small></div>
            :
            <div className="standings-fish-new"><small>{type}</small></div>
          }
        
          <div className="icon-row">
          <a target="#" onClick={handleShow}>
            {(status === "1" || status === 1)
              ? <img src="/leaderboard/green28x.png" alt="Click to view" title="Click to view"/>
              : <img src="/leaderboard/red28x.png" alt="Click to view" title="Click to view"/>}
          </a>
          </div>

          <Modal dialogClassName="pic-modal" show={show} onHide={handleClose} animation={false} centered>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body style={{'height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} >
                <div className='fish-img'>
                  <img src={`${txdomain}/app/lib/php/show_image.php?s=${photo}`} onClick={handleClose}
                    onError={(e) => e.target.src = '/no_submit_photo2.jpg'} />
                </div>        
              </Modal.Body>
          </Modal>

        </td>
    
    )
 }else{
    return (

      // Below condition is for super-admin role 
      //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day display fish caught day with fish length. function call.
      (user_information && user_information.role === '1') ?

      <td className="center">
        <small className="submission-fish-id">ID:{photo}</small>
        <br></br>
        {
        //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day display fish caught day with fish length. 
        (fish_caught_day && fish_caught_day >= '1') 
        ? getSubmissionFishCaught() 
        :
        ''
        }
        {getSubmissionWeightScores()}

      
        { (status === "1" || status === 1)
          ?
          <div className="standings-fish-accepted"><small>{type}</small></div>
          :
          <div className="standings-fish-new"><small>{type}</small></div>
        }

        <div className="icon-row">
        <a target="#" onClick={handleShow}>
          {(status === "1" || status === 1)
            ? <img  src="/leaderboard/green28x.png" alt="Click to view" title="Click to view"/>
            : <img src="/leaderboard/red28x.png" alt="Click to view" title="Click to view"/>}
        </a>
        </div>

        <Modal dialogClassName="pic-modal" show={show} onHide={handleClose} animation={false} centered>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body style={{'height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} >
            <div className='fish-img'>
              <img src={`${txdomain}/app/lib/php/show_image.php?s=${photo}`} onClick={handleClose}
                onError={(e) => e.target.src = '/no_submit_photo2.jpg'} />
            </div>          
          </Modal.Body>
        </Modal>
      </td>

      :

      // Below condition is for other users  
      //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day display fish caught day with fish length. function call.
      <td className={`center ${hide_fish_records && hide_fish_records == '1' ? 'opacity-class' :''}`}>
  
      {getSubmissionFishCaught()}
      {getSubmissionWeightScores()}

      { (status === "1" || status === 1)
        ?
        <div className="standings-fish-accepted"><small>{type}</small></div>
        :
        <div className="standings-fish-new"><small>{type}</small></div>
      }

      <div className="icon-row">
      <a target="#" onClick={handleShow}>
        {(status === "1" || status === 1)
          ? <img  src="/leaderboard/green28x.png" alt="Click to view" title="Click to view"/>
          : <img  src="/leaderboard/red28x.png" alt="Click to view" title="Click to view"/>}
      </a>
      </div>

      <Modal dialogClassName="pic-modal" show={show} onHide={handleClose} animation={false} centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body style={{'height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} >
          <div className='fish-img'>
            <img src={`${txdomain}/app/lib/php/show_image.php?s=${photo}`} onClick={handleClose}
              onError={(e) => e.target.src = '/no_submit_photo2.jpg'} />
          </div>          
        </Modal.Body>
    
      </Modal>
    </td>



    )
 }

}

export default StandingsFish